module.exports = __webpack_public_path__ + "img/dyq26_detail.953358f1.png";